

















import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'MissionLeftIcon',
  props: {
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
  },
})
